import React, { useState } from 'react';

export default function WindowsGroup({ dataRule }) {
    return <div className="dm-container dm-no-padding">
        WindowsGroup
    </div>;
}